import { Slider } from '~src/components/Slider';
import { SliderProps } from '~src/components/Slider/types';
import { useDisplayContext } from '~src/context/DisplayContext';

import { NumberInputNorlys } from '../NumberInput';
import { SelectNorlys } from '../Select';
import { ContainerNorlys } from './style';
import { ResidenceFormInputProps, ResidenceFormProps } from './types';
import { getCalculatorResidenceFormInputProps } from './util';

export const ResidenceFormNorlys = ({ residence, guessedValues, onUpdate, style, locked }: ResidenceFormProps) => {
  const { isMobile } = useDisplayContext();

  const inputFieldProps = getCalculatorResidenceFormInputProps({
    residence,
    locked,
    guessedValues,
    onUpdate,
    ...(!isMobile && { style: { width: '40%' } }),
  }) as ResidenceFormInputProps[];

  if (!inputFieldProps) {
    return null;
  }

  const inputFieldList = inputFieldProps?.map((inputProps: ResidenceFormInputProps) => {
    const { inputType, label, placeholder } = inputProps;

    switch (inputType) {
      case 'number':
        return <NumberInputNorlys key={label || placeholder} {...inputProps} />;
      case 'select':
        return <SelectNorlys key={label || placeholder} {...inputProps} />;
      case 'slider':
        return <Slider key={label || placeholder} {...(inputProps as SliderProps)} />;
      default:
        return null;
    }
  });

  return <ContainerNorlys style={style}>{inputFieldList}</ContainerNorlys>;
};
